import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token= sessionStorage.getItem('AccessToken')
    let isApiUrl = request.url.startsWith(environment.baseUrl);
    if (token && isApiUrl) {
      request = request.clone({
          setHeaders: {
              Authorization: `Bearer ${sessionStorage.getItem('AccessToken')}`
          }
      });
  }
    return next.handle(request);
  }
}
